export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7958.c77c7447.jpg";